import React, { Component } from "react";
import { MdSearch, MdInfo } from "react-icons/md";
import swal from "@sweetalert/with-react";
import io from "socket.io-client";
const url = "https://transacoes-api.all.com.br:3080";

let value = "";

class SearchQuery extends Component {
  state = {
    placeholder: "Pesquisar por malote..."
  };

  socket = io(url);

  async componentDidMount() {
    this.eventListenerSocket();
    value = "";
  }

  eventListenerSocket = () => {
    this.socket.on("data", () => {
      value = "";
      if (this.refs.search) this.refs.search.value = "";
    });
  };

  showInformation = () => {
    swal({
      title: "Pesquisar por:",
      content: (
        <div>
          <h5>
            <p>
              <strong>Malotes: </strong>
              ID malote, data/horário de criação e modificação, status.
            </p>
          </h5>
          <h5>
            <p>
              <strong>Movimentações: </strong>
              ID malote, ID movimentação, ID item, remetente, destinatário,
              data/horário de criação e modificação, status.
            </p>
          </h5>
          <h5>
            <p>
              <strong>Itens: </strong>
              ID item, tipo, destinatário, descrição, código/patrimônio,
              observação, status.
            </p>
          </h5>
          <br />
          <p>
            <strong>Observação: </strong>
            Malotes concluídos serão exibidos em um intervalo de 7 dias a partir
            do seu registro.
          </p>
        </div>
      ),
      icon: "info"
    });
  };

  setValue = e => {
    value = e;
    this.props.handleSearch(value);
  };

  setFilter = e => {
    this.props.handleSearch(value);
    this.props.handleFilter(e);
    if (e.includes("transactions")) {
      this.refs.search.placeholder = "Pesquisar por malote...";
      this.refs.transactions.checked = true;
      this.refs.movements.checked = false;
      this.refs.items.checked = false;
    } else if (e.includes("movements")) {
      this.refs.search.placeholder = "Pesquisar por movimentação...";
      this.refs.transactions.checked = false;
      this.refs.movements.checked = true;
      this.refs.items.checked = false;
    } else if (e.includes("items")) {
      this.refs.search.placeholder = "Pesquisar por item...";
      this.refs.transactions.checked = false;
      this.refs.movements.checked = false;
      this.refs.items.checked = true;
    }
  };

  render() {
    return (
      <React.Fragment>
        <div
          className="container"
          style={{
            position: "relative"
          }}
        >
          <div
            className="row justify-content-center"
            style={{ paddingTop: "25px" }}
          >
            <div className="col-12">
              <form
                className="box-search"
                style={{
                  backgroundColor: "none",
                  boxShadow:
                    "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)"
                }}
              >
                <div
                  className=" row align-items-center"
                  style={{
                    marginLeft: "0",
                    marginRight: "0"
                  }}
                >
                  <div className="col s12">
                    <input
                      ref="search"
                      style={{ marginTop: "10px" }}
                      type="text"
                      required
                      onChange={e => this.setValue(e.target.value)}
                      placeholder="Pesquisar por malote..."
                    />
                  </div>

                  <div className="col-auto" style={{ fontSize: "1.5rem" }}>
                    <MdSearch style={{ marginTop: "20px" }} />
                  </div>
                </div>
                <div
                  className="row justify-content-center"
                  style={{
                    marginLeft: "0",
                    marginRight: "0"
                  }}
                >
                  <div className="col s12">
                    <div className="filters">
                      <div className="right">
                        <MdInfo
                          style={{ width: "1rem" }}
                          onClick={() => this.showInformation()}
                        />
                      </div>
                      <span style={{ padding: "5px" }}>
                        <input
                          ref="transactions"
                          type="checkbox"
                          defaultChecked={true}
                          defaultValue="transactions"
                          id="transactions"
                          name="transactions"
                          autoFocus
                          onChange={e => this.setFilter(e.target.value)}
                        />
                        <label htmlFor="transactions">Malotes</label>
                      </span>
                      <span style={{ padding: "5px" }}>
                        <input
                          ref="movements"
                          type="checkbox"
                          defaultChecked={false}
                          defaultValue="movements"
                          id="movements"
                          name="movements"
                          onChange={e => this.setFilter(e.target.value)}
                        />
                        <label htmlFor="movements">Movimentações</label>
                      </span>
                      <span style={{ padding: "5px" }}>
                        <input
                          ref="items"
                          type="checkbox"
                          defaultChecked={false}
                          defaultValue="items"
                          id="items"
                          name="items"
                          onChange={e => this.setFilter(e.target.value)}
                        />
                        <label htmlFor="items">Itens</label>
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SearchQuery;
